import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useEffect, useState } from "react";
import configuration from "../../config";
import { toast } from "react-toastify";
import labels from "../../constants/Tax";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// Add Tax
function Add({ history }) {
  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];
  const typeOpt = [
    { id: 1, title: "Percentage", value: "percentage" },
    { id: 2, title: "Amount", value: "amount" },
  ];
  const fieldArr = [
    { id: 0, title: "Title", name: "name", type: "TextInput" },
    { id: 1, title: "Type", name: "type", type: "Dropdown", options: typeOpt },
    {
      id: 2,
      title: "Value",
      name: "value",
      type: "TextInput",
      is_number: true,
    },
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
  ];

  const [isLoader, setIsLoader] = useState(false);
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({
    name: "",
    type: "",
    value: "",
    status: "",
  });

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "TAX");
      if (rightsData?.add === false) {
        history.push("/dashboard");
      }
    });
  }, []);

  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.name) {
      error["name"] = "Please enter tax name";
      flag = false;
    }

    if (!fields.value) {
      error["value"] = "Please enter value ";
      flag = false;
    }
    if (!fields.type) {
      error["type"] = "Please select type";
      flag = false;
    }
    if (!fields.status) {
      error["status"] = "Please select status";
      flag = false;
    }
    setErrors({ ...error });
    return flag;
  }

  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      configuration
        .postAPI({ url: "tax/create", params: fields })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            history.push("/tax");
            toast.success("Record added successfully");
          } else if (data.error) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };

  // function handleChange(field, e) {
  //   if (fields === 'value') {
  //     if (e.target.value) {
  //       setFields({ ...fields, [field]: e.target.value });
  //     }
  //   } else {
  //     setFields({ ...fields, [field]: e.target.value });
  //   }
  // }
  function handleChange(field, e) {
    setFields({ ...fields, [field]: e.target.value });
  }
  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.addTax} />
      <AddEditSection
        title="Add Tax"
        path="/tax"
        fields={fieldArr}
        fieldError={errors}
        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
